import { Component, OnInit } from '@angular/core';
import { ErrorService } from '@modules/error/services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent implements OnInit {

  constructor(public errorService: ErrorService) { }

  ngOnInit() {
    
  }

  clear(){
    this.errorService.clear();
  }

}
